import { remplazarPorTildeASinTilde, filter } from "../../helpers/Buscador";
import { types } from "../../types/types";

const initialState = {
  grupos: [],
  itemAuxGrupos: [],
  practicas: [],
  itemAuxPracticas: [],
};

export const practicasAgrupadasReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.practicasAgrupadasTraerGruposSuccess:
      return {
        ...state,
        grupos: action.payload,
        itemAuxGrupos: action.payload
      };
    case types.practicasAgrupadasBuscarGrupo:
      const itemsResults = state.itemAuxGrupos.filter(n => filter(remplazarPorTildeASinTilde(n.nombre), remplazarPorTildeASinTilde(action.payload)))
      return {
        ...state,
        grupos: itemsResults
      };
    case types.practicasAgrupadasTraerGruposError:
      return {
        ...state,
        grupos: [],
        itemAuxGrupos: []
      };
    
    case types.practicasAgrupadasTraerPracticasSuccess:
      return {
        ...state,
        practicas: action.payload,
        itemAuxPracticas: action.payload
      };
    case types.practicasAgrupadasTraerPracticasError:
      return {
        ...state,
        practicas: [],
        itemAuxPracticas: [],
      };
    case types.practicasAgrupadasBuscarPractica:
      let itemsResultsPr = state.itemAuxPracticas.filter(n => filter(n.practica.codNomPlano, action.payload));
      if(itemsResultsPr.length === 0)
        itemsResultsPr = state.itemAuxPracticas.filter(n => filter(remplazarPorTildeASinTilde(n.practica.desNom), remplazarPorTildeASinTilde(action.payload)))

      return {
        ...state,
        practicas: itemsResultsPr
      };
    default:
      return state;
  }
};
